var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTick2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 16,
    viewBox: "0 0 20 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_135_283)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.03956 15.9983C6.97726 15.9984 6.91558 15.9838 6.85801 15.9554C6.80045 15.9271 6.74814 15.8854 6.70409 15.833L0.136924 8.01018C0.0506136 7.90374 0.00285986 7.76118 0.00393942 7.6132C0.00501899 7.46523 0.0548577 7.32368 0.142708 7.21904C0.230558 7.1144 0.349385 7.05503 0.473619 7.05375C0.597854 7.05246 0.71755 7.10936 0.806914 7.21216L7.03956 14.6376L19.1893 0.165385C19.2782 0.0594857 19.3988 0 19.5245 0C19.6503 0 19.7708 0.0594857 19.8597 0.165385C19.9486 0.271285 19.9986 0.414912 19.9986 0.564677C19.9986 0.714441 19.9486 0.858083 19.8597 0.963982L7.37454 15.8352C7.2854 15.9403 7.16494 15.9989 7.03956 15.9983Z",
    fill: "#00FF00"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_135_283"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 16,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTick2);
export default __webpack_public_path__ + "static/media/tick2.bdcb761701fbd356c2923f88273646b1.svg";
export { ForwardRef as ReactComponent };